const initialState = {
  funds: [],
  loading: false,
  error: null,
};

const fundReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_FUNDS':
      return {
        ...state,
        funds: [...state.funds, action.payload],
      };
    case 'SET_FUNDS':
      return {
        ...state,
        funds: action.payload,
      };
    case 'UPDATE_FUNDS':
      return {
        ...state,
        funds: state.funds.map(fund =>
          fund.id === action.payload.id ? action.payload : fund
        ),
      };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fundReducer;